import { gateway } from "../../../gateway";

export const checkCompanyAvailability = async (email: string) => {
    try {
        const response = await gateway.get(`/companies/check-email?email=${email.toLowerCase().trim()}`);
        const { isAvailable } = response?.data?.data || response?.data;
        return isAvailable === true;
    } catch (error) {
        console.error("Company check error:", error);
        return false;
    }
};
